export default __webpack_public_path__ + "static/media/person_3@3x.70c09ea9.png";